import React from 'react';
import { useTranslations } from 'i18n';
import { Spinner } from 'ui';

type CentredSpinnerProps = {
    minHeight?: string;
    testId?: string;
    /** referee's old `variant` name, mapped onto the ui Spinner's `color` */
    variant?: 'primary' | 'secondary';
    label?: string;
    /** Off by default: page-level loading states announce, so many spinners do not chatter at once. */
    announce?: boolean;
};

export const CentredSpinner: React.FC<CentredSpinnerProps> = (props) => {
    const { minHeight = '80px', testId, variant, label, announce = false } = props;
    const { __ } = useTranslations();

    return (
        <div
            style={{
                alignItems: 'center',
                display: 'flex',
                height: '100%',
                justifyContent: 'center',
                minHeight,
                width: '100%',
            }}
        >
            <Spinner testId={testId} color={variant} label={label ?? __('misc.loading')} announce={announce} />
        </div>
    );
};
